import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=2a778f0a&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=2a778f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a778f0a",
  null
  
)

export default component.exports